import React from "react"
import { T } from "../../traks"

export const AlertText = ({text, ...props}) => {
	console.log(text)
	switch(text) {
		case "Your case has been successfully submitted!":
			return <T>Your case has been successfully submitted!</T>
		case "Entry successfully shared":
			return <T>Entry successfully shared</T>
		case "settings updated":
			return <T>settings updated</T>
		case "Request sent, you will be contacted by our sales team":
			return <T>Request sent, you will be contacted by our sales team</T>
		case "Entry deleted":
			return <T>Entry deleted</T>
		case "An email has been sent":
			return <T>An email has been sent</T>
		case "your password was reset":
			return <T>your password was reset</T>
		case "link deleted":
			return <T>link deleted</T>
		case "Entry successfully re-assigned":
			return <T>Entry successfully re-assigned</T>
		default:
			return text
	}
}
